export const EXTERNAL_LINKS = {
  sejam: {
    key: 'sejam',
    title: 'سامانه سجام',
    name: 'مراجعه به سامانه سجام',
    href: 'https://www.sejam.ir',
  },
}
